import { Drawer, styled } from "@mui/material";

const StyledDrawer = styled(Drawer)(() => ({
  "& .MuiDrawer-paper": {
    backgroundColor: "var(--bkg-secondary)",
    color: "var(--text-primary)",
    minWidth: "fit-content",
    width: "25vw",
    overflowX: "hidden",
  },
}));

const SidebarDrawer = ({ open, onClose, anchor, children }) => {
  return (
    <StyledDrawer open={open} anchor={anchor} onClose={onClose}>
      {children}
    </StyledDrawer>
  );
};

export default SidebarDrawer;
